module.exports = __webpack_public_path__ + "static/media/Sharon Law (PPE)-min.7704d64a.jpg";